import { isE2ETestBuild } from "@client/utils/environment";

/**
 * Test seam: `e2ePostHogProbe=true` in localStorage makes the web entry
 * initialize PostHog against THIS origin's `/ph` path with product analytics
 * on and the SDK's bot filter off, so an e2e run can watch the requests the
 * real SDK plus our request seam actually produce. Nothing else changes.
 *
 * Why it exists: ad blockers judge requests by URL shape, and the only honest
 * way to know our shape still passes is to send the real one. posthog-js
 * drops every capture when `navigator.webdriver` is set, so without the
 * filter switch no automated browser could ever exercise this path — which
 * is how a funder's telemetry stayed dark for two months unnoticed.
 *
 * Available only in dev builds and under `VITE_E2E_TEST_SEAMS=true` (the e2e
 * prod-build mode; real deploys never set it), like the other `e2e*` seams.
 * A shipped bundle evaluates it to `false` at runtime (Vite does not fold
 * the env read away); the caller asks only when a PostHog key is baked in,
 * so a keyless build drops this module and the SDK altogether.
 */
export function isE2EPostHogProbe(): boolean {
  if (!(import.meta.env.DEV || isE2ETestBuild())) {
    return false;
  }

  try {
    return window.localStorage.getItem("e2ePostHogProbe") === "true";
  } catch {
    return false;
  }
}
